export default __webpack_public_path__ + "static/media/6.a328949e.jpg";